import { render, staticRenderFns } from "./PGoThrough.vue?vue&type=template&id=67b2f16a&scoped=true&"
import script from "./PGoThrough.vue?vue&type=script&lang=js&"
export * from "./PGoThrough.vue?vue&type=script&lang=js&"
import style0 from "./PGoThrough.vue?vue&type=style&index=0&id=67b2f16a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b2f16a",
  null
  
)

export default component.exports